import PubSub from "underpub-js";
import Masonry from 'masonry-layout';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

var ListingThreeUpPeople = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ListingThreeUpPeople',
	};

	$.extend(true, this.options, options);

};

ListingThreeUpPeople.prototype.init = function() {

	var self = this;

	self.$grid = self.options.$el.find(`.${self.options.baseClass}__listings`);
	self.itemClass = `.${self.options.baseClass}__listingItem`;
	self.$item = self.options.$el.find(self.itemClass);
	// self.$gutterSizer = self.options.$el.find(`.${self.options.baseClass}__gutterSizer`);

	self.initScrollAnimation();

};

// ListingThreeUpPeople.prototype.initGrid = function() {

// 	const self = this;

	// new Masonry(self.$grid[0], {
	// 	itemSelector: self.itemClass,
	// 	transitionDuration: '0.3s',
	// 	gutter: self.$gutterSizer[0],
	// 	percentPosition: true,
	// });

	

// };

ListingThreeUpPeople.prototype.initScrollAnimation = function() {

	const self = this;

	self.$item.each((i, el) => {

		gsap.fromTo(el, 
		{
			y: 32,
		},
		{
			scrollTrigger: {
				trigger: el,
				start: 'top bottom-=60px',
			},
			duration: 0.6,
			ease: 'expo.easein',
			y: 0,
			opacity: 1,
		});

	});

};

export default ListingThreeUpPeople;
